<div class="mat-table orders-table">
  <div class="mat-header-row">
    <div class="mat-header-cell">Order</div>
    <div class="mat-header-cell">Date</div>
    <div class="mat-header-cell">Status</div>
    <div class="mat-header-cell text-right">Total
    </div>
    <div class="mat-header-cell"></div>
    <div class="mat-header-cell"></div>
  </div>
  <div *ngFor="let order of orderItem" class="mat-row">
    <div class="mat-cell"><span class="order">{{order.orderId}}</span></div>
    <div class="mat-cell">{{order.orderDate}}</div>
    <div class="mat-cell">Order Confirmed</div>
    <div class="mat-cell text-right">{{order.orderTotal}}</div>
    <div class="mat-cell">
      <div class="p-1 actions">
        <a [routerLink]="['/account/orderdetails', order.orderId]" mat-mini-fab color="primary" matTooltip="View">
          <mat-icon>remove_red_eye</mat-icon>
        </a>

        <!-- <button *ngIf="order.invoice" mat-mini-fab color="warn" matTooltip="View invoice" class="btn-invoice">
          <mat-icon>receipt</mat-icon>
        </button> -->
      </div>
    </div>
    <div class="mat-cell">
      <button mat-raised-button color="warn" (click)="(orderCancel(order.orderId))" class="mat-elevation-z6">
        <mat-label>Order Cancel</mat-label>
      </button>
    </div>
  </div>
</div>